import React, { useState } from 'react';
import styled from 'styled-components';

import { Button, Header, Icon, Input, Modal, Table } from 'semantic-ui-react';

import RepositoryContentListModal from '../repository-management/components/RepositoryContentListModal';

export const ResourceModal = ({
  phaseIndex,
  open,
  onClose,
  resources,
  addResource,
  removeResource,
  updateResourceInfo,
}) => {
  const [isFileSelectOpen, setIsFileSelectOpen] = useState(false);

  const handleAddResource = () => {
    // Always open the repository picker modal
    setIsFileSelectOpen(true);
  };

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Header icon="linkify" content="Manage Resources" />
      <Modal.Content scrolling>
        <Table celled structured>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={8}>Resource Text</Table.HeaderCell>
              <Table.HeaderCell width={5}>Resource URL</Table.HeaderCell>
              <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {resources.map((resource, index) => (
              <Table.Row key={index}>
                <Table.Cell>
                  <Input
                    disabled
                    readOnly
                    value={resource.name || resource.text || ''}
                    style={{ width: '100%' }}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    disabled
                    readOnly
                    value={resource.object_key || resource.url || ''}
                    style={{ width: '100%' }}
                  />
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <IconButton
                    icon
                    title="Delete Task"
                    onClick={() => removeResource(phaseIndex, index)}
                  >
                    <Icon name="trash alternate" color="grey" />
                  </IconButton>
                </Table.Cell>
              </Table.Row>
            ))}
            <Table.Row>
              <Table.Cell colSpan="4" textAlign="left">
                <Button icon labelPosition="left" primary onClick={handleAddResource}>
                  <Icon name="folder open" />
                  Select from Repository
                </Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>

      <RepositoryContentListModal
        open={isFileSelectOpen}
        onItemClicked={item => {
          addResource(
            phaseIndex,
            { id: item.id, name: item.name, object_key: item.object_key, type: item.type }
          );
          setIsFileSelectOpen(false);
        }}
        onClose={() => setIsFileSelectOpen(false)}
      />
    </Modal>
  );
};

const IconButton = styled(Button)`
  padding: 8px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  color: #d9534f !important;
`;
